module.exports = "/fonts/opensansbolditalic.woff2";